
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a9cdcba0&scoped=true!less-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WKheader.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./WKheader.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-a9cdcba0!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WKheader.vue"),
  /* scopeId */
  "data-v-a9cdcba0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/WKheader.vue
// module id = 140
// module chunks = 10